var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.travelFilter = {
	categoryVal: 'all',
	services: undefined,
	mapItems: undefined,
	initialized: false,

	init: function() {
		var $body = $('body');
		if (!$body.is('.travel-vest') || $body.is('.admin') ) return;

		var $travelVest = $('#travel-vest');
		var $categoryFilter = $travelVest.find('#categoryFilter');
		site.travelFilter.services = $travelVest.find('.travelVest__services .travelVest__service');

		$categoryFilter.on('change', site.travelFilter.handleCategoryChange);

		var $hash = location.hash.substr(1);
		if ($hash.length > 0) {
			if($hash === 'allir-flokkar') {
				$hash = 'all';
			} else {
				site.travelFilter.setHash($hash);
			}
			site.travelFilter.categoryVal  = $hash;
			site.travelFilter.updateVisibility();
			document.getElementById('categoryFilter').value=$hash;
		}
	},

	handleCategoryChange: function() {
		site.travelFilter.categoryVal = $(this).val();
		site.travelFilter.updateVisibility();
	},

	updateVisibility: function() {
		var $catVal = site.travelFilter.categoryVal;
		site.travelFilter.services.hide();

		if ($catVal === 'all') {
			location.hash = 'allir-flokkar'
		} else {
			location.hash = site.travelFilter.categoryVal;
		}
		site.travelFilter.setHash($catVal);
		
		site.travelFilter.services.filter(function() {
				if ($catVal === 'all') {
					return true;
				} else {
					return $(this).is('.' + $catVal);
				}
			}
		).show();
	},
	setHash: function(hash) {
		if (hash && document.readyState === 'interactive' && !site.travelFilter.initialized) {
			setTimeout(function() {
				site.travelFilter.setHash(hash);
			}, 300);
			site.travelFilter.initialized = true;
		}
		if (moya.map.osmMap && moya.map.markers.length > 1) {
			moya.map.osmMap.closePopup();

			var map = moya.map.osmMap;
			var markers = map.options.markers;

			$.each(map._layers, function() {
				var layer = $(this)[0];
				if (layer._icon || layer._featureGroup) {
					map.removeLayer(layer);
				}
			});

			if (hash) {
				var filteredMarkes = [];
				$.each(markers, function() {
					var marker = $(this)[0];
					if ((marker.tags && marker.tags.indexOf(hash) >= 0) || hash === 'all') {
						filteredMarkes.push(marker);
					}
				});
				if (filteredMarkes.length > 0) {
					moya.map.addMarkers(filteredMarkes, map, moya.map.osmMap.options);
				}
			}
			else {
				moya.map.addMarkers(markers, map, moya.map.osmMap.options);
			}
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};


site.frontpage = {
	init: function() {
		site.frontpage.scroll();

		site.owl.init('.box_instagram .social__instagram', {
			items: 1,
			nav: true,
			navText: ['', ''],
			autoHeight: true,
			loop: true,
			dots: false,
			responsive: {
				480: {
					items: 2,
					slideBy: 2
				},
				768: {
					items: 6,
					slideBy: 5
				}
			}
		});

		if ($('li', '#map-banner ul').length > 1) {
			var prev, next;
			document.documentElement.lang === 'is' ? (prev = 'Sumarleið', next = 'Vetrarleið') : (prev = 'Summer route', next = 'Winter route');

			site.owl.init('#map-banner ul', {
				loop: false,
				dots: false,
				mouseDrag: false,
				touchDrag: false,
				nav: true,
				smartSpeed: 1000,
				items: 1,
				navText: ["<div class=\"btn btn-primary\">" + prev + "</div>", "<div class=\"btn btn-primary\">" + next + "</div>"]
			});
		}
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	site.travelFilter.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
